var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.155C5.93651 11.155 7.33333 6.29558 7.33333 3.73333C7.33333 9.91807 12.2222 11.155 14.6667 11.155C8.55556 11.155 7.33333 15.9261 7.33333 18.4C7.33333 12.5687 2.44444 11.155 0 11.155Z",
    fill: "#0D47A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2667 18.0908C14.1254 18.0908 15.0333 14.9321 15.0333 13.2667C15.0333 17.2867 18.2111 18.0908 19.8 18.0908C15.8278 18.0908 15.0333 21.192 15.0333 22.8C15.0333 19.0096 11.8556 18.0908 10.2667 18.0908Z",
    fill: "#1E88E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 6.71084C17.6349 6.71084 18.3333 4.28112 18.3333 3C18.3333 6.09237 20.7778 6.71084 22 6.71084C18.9444 6.71084 18.3333 9.09639 18.3333 10.3333C18.3333 7.41767 15.8889 6.71084 14.6667 6.71084Z",
    fill: "#42A5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAi);
export default __webpack_public_path__ + "static/media/ic_ai.e79d90bb24d428c42bab5c78acb1ae93.svg";
export { ForwardRef as ReactComponent };